export default __webpack_public_path__ + "static/media/siteLogo.b643489f.png";